import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "57",
  height: "57",
  viewBox: "0 0 57 57",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g id=\"Group 1444\"><path id=\"Vector\" d=\"M57 0H0V57H57V0Z\" fill=\"#F6E4B2\"></path><path id=\"Vector_2\" d=\"M28.436 3.10308L3.22168 28.3174L28.5755 53.6712L53.7898 28.4569L28.436 3.10308Z\" fill=\"#4B291D\"></path><path id=\"Vector_3\" d=\"M50.1552 24.8321L24.9453 50.0508L28.5668 53.671L53.7767 28.4523L50.1552 24.8321Z\" fill=\"#9C5B23\"></path><path id=\"Vector_4\" d=\"M42.936 17.5963L17.7173 42.8062L21.3375 46.4276L46.5561 21.2177L42.936 17.5963Z\" fill=\"#9C5B23\"></path><path id=\"Vector_5\" d=\"M35.6738 10.3423L10.4595 35.5566L14.0803 39.1774L39.2946 13.9631L35.6738 10.3423Z\" fill=\"#9C5B23\"></path><path id=\"Vector_6\" d=\"M28.4223 3.09725L3.20801 28.3115L6.82882 31.9323L32.0431 6.71806L28.4223 3.09725Z\" fill=\"#9C5B23\"></path></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }